export default __webpack_public_path__ + "static/theCoalition-80d568b556fc8a0c1e375ce671f2c089.jpg";